import PropTypes from "prop-types";
import classNames from "classnames";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { getColorClass } from "../../../utils/teacher/InputRatingUtils";

/**
 * Per-cell comment icon for the differentiated bulk grid.
 * Filled when a comment exists; outline "add" only when the cell is rated and editable.
 */
const DiffCellCommentIcon = ({ canEdit, comment, onOpen, rating, studentKey, contentId }) => {
    const commentExists = comment?.trim();
    const tooltipId = `tooltip-diff-${studentKey}-${contentId}`;

    if (commentExists) {
        return (
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id={tooltipId}>
                        {commentExists.length > 100 ? `${commentExists.slice(0, 100)}...` : commentExists}
                    </Tooltip>
                }
            >
                <button
                    type="button"
                    className="comment-icon bi bi-chat-left-dots-fill"
                    aria-label={canEdit ? "Edit Comment" : "View Comment"}
                    onClick={onOpen}
                    style={{ border: "none", background: "none", padding: 0 }}
                />
            </OverlayTrigger>
        );
    }

    if (!canEdit || !rating) return null;

    return (
        <button
            type="button"
            className={classNames(`${getColorClass(rating)}-icon`, "comment-icon", "bi bi-chat-left-dots")}
            aria-label="Add comment"
            onClick={onOpen}
            style={{ border: "none", background: "none", padding: 0 }}
        />
    );
};

DiffCellCommentIcon.propTypes = {
    canEdit: PropTypes.bool,
    comment: PropTypes.string,
    contentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onOpen: PropTypes.func.isRequired,
    rating: PropTypes.string,
    studentKey: PropTypes.string.isRequired
};

export default DiffCellCommentIcon;
